import { lazyLoad } from 'utils/loadable';

export const CatalogList = lazyLoad(
  () => import('./catalogList.page'),
  (module) => module.CatalogList
);
